// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'

Vue.config.productionTip = false
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI)
import 'babel-polyfill';
import commonComponent from './components/public'

Vue.use(commonComponent)
import 'vant/lib/index.css';
import vant from "vant"
import VueTouchKeyboard from "vue-touch-keyboard";
import "vue-touch-keyboard/dist/vue-touch-keyboard.css"; // load default style
Vue.use(VueTouchKeyboard);
Vue.use(vant)
import Common from "@/utils/index";
import 'lib-flexible'

Vue.use(Common);
Number.prototype.add = function (arg) {
  var r1, r2, m;
  try {
    r1 = this.toString().split(".")[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg.toString().split(".")[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (this * m + arg * m) / m
}

router.beforeEach((to, from, next) => {
  var app = document.getElementById("app")

  var token = localStorage.getItem("token")
  if (to.meta.notoken) {
    next()
  } else {
    const acctoken = to.query.token
    if (((token === '' || token == null) && to.path !== '/' && (acctoken === "" || acctoken == undefined))) {
      next('/')
    } else {
      next()
    }
  }
})
Vue.directive('preventReClick', {

  inserted(el, binding) {

    el.addEventListener('click', () => {
      el.setAttribute('style', 'pointer-events: none;')
      setTimeout(() => {
        el.setAttribute('style', 'pointer-events: auto;')
      }, binding.value || 3000)
    })

  }

})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js